import { useEffect } from "react";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import { GiftAnArticleButonFactory } from "@features/giftAnArticle/utils/helpers";
import { GiftAnArticleVersion } from "@features/giftAnArticle/utils/types";
import { LambdaResponsePayload } from "@pages/Article/types/Alacrity";
import useOKTAUserStore, { OKTAUserTypeEnum } from "@store/useOKTAUserStore";

export type ArticleSubshareProps = {
  isPremium: boolean;
  userType?: OKTAUserTypeEnum;
  handleGenerateGiftURLModal: () => void;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  alacrityRes?: LambdaResponsePayload;
  displayNewGiftIcon?: boolean;
  subshareVersion?: GiftAnArticleVersion;
  buttonClassname?: string;
};

export default function ArticleSubshare({
  isPremium = false,
  handleGenerateGiftURLModal,
  setIsModalOpen,
  alacrityRes,
  subshareVersion = GiftAnArticleVersion.default,
  buttonClassname,
}: ArticleSubshareProps): React.ReactElement {
  const OKTAUserInfo = useOKTAUserStore((state) => state.userInfo);
  const userType = OKTAUserInfo?.usertype;

  const sendDataToGTM = useGTMDispatch();

  const handleClick = () => {
    sendDataToGTM({
      event: "custom_event",
      eventCategory: "bt subshare",
      eventAction: "click",
      eventLabel: "gift icon clicks for subscribers",
      nonInteraction: false,
    });

    if (alacrityRes) {
      setIsModalOpen(true);
    } else {
      handleGenerateGiftURLModal();
    }
  };

  useEffect(() => {
    if (!isPremium) return;
    if (userType !== OKTAUserTypeEnum.SUBSCRIBER) return;

    sendDataToGTM({
      event: "custom_event",
      eventCategory: "bt subshare",
      eventAction: "views",
      eventLabel: "gift icon exposure for subscribers",
      nonInteraction: false,
    });
  }, [isPremium, userType, sendDataToGTM]);

  const GiftAnArticleButton = GiftAnArticleButonFactory({
    giftAnArticleVersion: subshareVersion,
  });

  return (
    <>
      {isPremium && userType === OKTAUserTypeEnum.SUBSCRIBER ? (
        <div data-testid="article-subshare-component" className="h-full">
          <GiftAnArticleButton
            handleClick={handleClick}
            className={buttonClassname}
          />
        </div>
      ) : null}
    </>
  );
}
